export const Permissions = {
  // Societies
  SOCIETY_READ: 'society.read',
  SOCIETY_CREATE: 'society.create',
  SOCIETY_UPDATE: 'society.update',
  SOCIETY_DELETE: 'society.delete',
  SOCIETY_STRUCTURE_CONFIG: 'society.structure_config',

  // Blocks
  BLOCK_READ: 'block.read',
  BLOCK_CREATE: 'block.create',
  BLOCK_UPDATE: 'block.update',
  BLOCK_DELETE: 'block.delete',

  // Floors
  FLOOR_READ: 'floor.read',
  FLOOR_CREATE: 'floor.create',
  FLOOR_UPDATE: 'floor.update',
  FLOOR_DELETE: 'floor.delete',

  // Flats
  FLAT_READ: 'flat.read',
  FLAT_CREATE: 'flat.create',
  FLAT_UPDATE: 'flat.update',
  FLAT_DELETE: 'flat.delete',
  PRIMARY_OWNER_ASSIGN: 'primary_owner.assign',

  // Bungalows
  BUNGALOW_READ: 'bungalow.read',
  BUNGALOW_CREATE: 'bungalow.create',
  BUNGALOW_UPDATE: 'bungalow.update',
  BUNGALOW_DELETE: 'bungalow.delete',
  BUNGALOW_PRIMARY_OWNER_ASSIGN: 'bungalow_primary_owner.assign',

  // Residents (Persons)
  PERSON_READ: 'person.read',
  PERSON_CREATE: 'person.create',
  PERSON_UPDATE: 'person.update',
  PERSON_DELETE: 'person.delete',

  // Events
  EVENT_READ: 'event.read',
  EVENT_CREATE: 'event.create',
  EVENT_UPDATE: 'event.update',
  EVENT_DELETE: 'event.delete',
  EVENT_PUBLISH: 'event.publish',
  EVENT_CONFIG: 'event.config',

  // Collections
  COLLECTION_READ: 'collection.read',
  COLLECTION_CREATE: 'collection.create',
  COLLECTION_UPDATE: 'collection.update',

  // Payments
  PAYMENT_READ: 'payment.read',
  PAYMENT_CREATE: 'payment.create',
  PAYMENT_REVERSE: 'payment.reverse',

  // Payment Methods
  PAYMENT_METHOD_READ: 'payment_method.read',
  PAYMENT_METHOD_MANAGE: 'payment_method.manage',

  // Sponsorships
  SPONSORSHIP_READ: 'sponsorship.read',
  SPONSORSHIP_CREATE: 'sponsorship.create',
  SPONSORSHIP_UPDATE: 'sponsorship.update',
  SPONSORSHIP_DELETE: 'sponsorship.delete',
  SPONSORSHIP_PAYMENT_CREATE: 'sponsorship_payment.create',

  // Food Items
  FOOD_READ: 'food.read',
  FOOD_MANAGE: 'food.manage',

  // Dress Codes
  DRESS_CODE_READ: 'dress_code.read',
  DRESS_CODE_MANAGE: 'dress_code.manage',

  // Activities
  ACTIVITY_READ: 'activity.read',
  ACTIVITY_MANAGE: 'activity.manage',

  // ETL Imports
  IMPORT_UPLOAD: 'import.upload',
  IMPORT_VALIDATE: 'import.validate',
  IMPORT_COMMIT: 'import.commit',
  IMPORT_READ: 'import.read',

  // Reports
  REPORT_READ: 'report.read',
  REPORT_EXPORT: 'report.export',

  // Dashboards
  DASHBOARD_READ: 'dashboard.read',
  DASHBOARD_SYSTEM: 'dashboard.read',
  DASHBOARD_SOCIETY: 'dashboard.read',
  DASHBOARD_EVENT: 'dashboard.read',
  DASHBOARD_COLLECTION: 'dashboard.read',

  // Users
  USER_READ: 'user.read',
  USER_CREATE: 'user.create',
  USER_UPDATE: 'user.update',
  USER_DELETE: 'user.delete',

  // Roles
  ROLE_READ: 'role.read',
  ROLE_MANAGE: 'role.manage',
  ROLE_CREATE: 'role.manage',
  ROLE_UPDATE: 'role.manage',
  ROLE_DELETE: 'role.manage',

  // Circulars
  CIRCULAR_READ: 'circular.read',
  CIRCULAR_CREATE: 'circular.create',
  CIRCULAR_UPDATE: 'circular.update',
  CIRCULAR_DELETE: 'circular.delete',
  CIRCULAR_PUBLISH: 'circular.publish',

  // System Settings, Vendors & Category Masters
  SETTING_READ: 'setting.read',
  SETTING_UPDATE: 'setting.update',
  VENDOR_READ: 'vendor.read',
  VENDOR_CREATE: 'vendor.create',
  VENDOR_UPDATE: 'vendor.update',
  VENDOR_DELETE: 'vendor.delete',
  VENDOR_MANAGE: 'vendor.manage',
  EXPENSE_CATEGORY_READ: 'expense_category.read',
  EXPENSE_CATEGORY_CREATE: 'expense_category.create',
  EXPENSE_CATEGORY_UPDATE: 'expense_category.update',
  EXPENSE_CATEGORY_DELETE: 'expense_category.delete',
  EXPENSE_CATEGORY_MANAGE: 'expense_category.manage',
  INCOME_CATEGORY_READ: 'income_category.read',
  INCOME_CATEGORY_CREATE: 'income_category.create',
  INCOME_CATEGORY_UPDATE: 'income_category.update',
  INCOME_CATEGORY_DELETE: 'income_category.delete',
  INCOME_CATEGORY_MANAGE: 'income_category.manage',

  // Advertising
  ADVERTISEMENT_READ: 'advertisement.read',
  ADVERTISEMENT_CREATE: 'advertisement.create',
  ADVERTISEMENT_UPDATE: 'advertisement.update',
  ADVERTISEMENT_DELETE: 'advertisement.delete',
  ADVERTISEMENT_MANAGE: 'advertisement.manage',
  ADVERTISEMENT_CATEGORY_READ: 'advertisement_category.read',
  ADVERTISEMENT_CATEGORY_CREATE: 'advertisement_category.create',
  // Expenses
  EXPENSE_READ: 'expense.read',
  EXPENSE_CREATE: 'expense.create',
  EXPENSE_UPDATE: 'expense.update',
  EXPENSE_DELETE: 'expense.delete',
  EXPENSE_MANAGE: 'expense.manage',

  // Audit Logs
  AUDIT_READ: 'audit.read',
  AUDIT_LOG_READ: 'audit.read',

  // Contracts & Work Orders
  CONTRACT_READ: 'contract.read',
  CONTRACT_CREATE: 'contract.create',
  CONTRACT_UPDATE: 'contract.update',
  CONTRACT_DELETE: 'contract.delete',
  CONTRACT_APPROVE: 'contract.approve',
  CONTRACT_COMPLETE: 'contract.complete',
  CONTRACT_ITEM_MANAGE: 'contract_item.manage',
  CONTRACT_DOCUMENT_UPLOAD: 'contract_document.upload',
  CONTRACT_DOCUMENT_DELETE: 'contract_document.delete',
} as const;

export type PermissionCode = typeof Permissions[keyof typeof Permissions];
